import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  paperContent: {
    display: 'flex',
    gap: theme.spacing(2),
    justifyContent: 'flex-end',
  },
}));

export default useStyles;
